module.exports = __webpack_public_path__ + "048f645d200c04a8b0be3c4b91e3dc47.png";